
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount",
      function () {
        return require("private-next-pages/myaccount.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount"])
      });
    }
  